exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tip-text[data-v-0074fd39]{margin:0 0 0.21333rem;font-size:0.17333rem;line-height:1.65;color:#606266}", ""]);

// exports
